// ROOT export — SLUGS AND ORDERING METADATA ONLY, safe on EVERY platform (native, web,
// Node/bun seed, tests). It reads the checked-in `slides-manifest.gen.json` and never
// touches slide CONTENT: the manifest generator (`-build-slides-manifest.ts`) is the one
// place slide content is read, at build time. The actual MDX components live behind the
// separate `./components` subpath (see `components.metro.ts`), which only Metro can build
// (`require.context` over offline-compiled `.gen.js` files). Keeping the renderable catalogue off the
// root keeps a `getSlidesComponents()` (which could return a raw-MDX-string-returning
// component off Metro) out of the root's surface entirely.
//
// The `SlideComponent` type is re-exported here so consumers can annotate a slide without importing
// the `./components` catalogue (a type is erased at build time — no runtime MDX dependency).
export type { SlideComponent } from "#slide-component";
export {
  isAfterAnchor,
  isBeforeAnchor,
  isEndAnchor,
  isStartAnchor,
  type QuizManifestEntry,
  type QuizOptionSpec,
  type QuizSelect,
  type SlideAnchor,
  type SlideManifestEntry,
} from "#slide-anchor";
export {
  getQuizManifest,
  getQuizManifestEntryByKey,
  getQuizManifestEntryBySlug,
  isQuizAnswerCorrect,
} from "#quizzes-manifest-module";
export {
  getSlideKeyBySlug,
  getSlideKeys,
  getSlideManifest,
  getSlideManifestEntryByKey,
  getSlideManifestEntryBySlug,
  getSlideSlugByKey,
  getSlideSlugs,
} from "#slides-manifest-module";
